import { useNavigate } from 'react-router-dom';
import { List, Avatar, Tag, Spin, Typography } from 'antd';
import { ShopOutlined } from '@ant-design/icons';
import { useWisecureQuery } from '@wisecure/api-client/hooks';
import type { PendingValidationsResponse, PendingSocietyItem } from '@wisecure/api-client';
import { queryKeys } from '@/api/query-keys';
import { PageHeader } from '@/components/PageHeader';
import { StatusBadge } from '@/components/base';
import { success, error, warning } from '@/theme';

const { Text } = Typography;

export function SocietiesValidationPage() {
  const navigate = useNavigate();

  const { data, isLoading } = useWisecureQuery<PendingValidationsResponse>(
    queryKeys.dashboardPendingValidations,
    (client) => client.dashboard.dashboardControllerGetPendingValidations(),
  );

  const pendingSocieties = data?.pendingSocieties ?? [];

  if (isLoading) {
    return (
      <div style={{ textAlign: 'center', padding: 80 }}>
        <Spin size="large" />
      </div>
    );
  }

  return (
    <div>
      <PageHeader title="Validation des sociétés" subtitle={`${pendingSocieties.length} société(s) en attente`} />
      <List
        dataSource={pendingSocieties}
        renderItem={(item: PendingSocietyItem) => (
          <List.Item
            onClick={() => navigate(`/societies/${item.id}`)}
            style={{ cursor: 'pointer' }}
          >
            <List.Item.Meta
              avatar={<Avatar icon={<ShopOutlined />} />}
              title={
                <span>
                  {item.name}
                  {item.type && (
                    <StatusBadge status={item.type} />
                  )}
                </span>
              }
              description={
                <span>
                  {item.email && typeof item.email === 'string' && (
                    <Text type="secondary">{item.email}</Text>
                  )}
                  {item.status && (
                    <Tag
                      style={{
                        marginLeft: 8,
                        backgroundColor: `${item.status === 'VALIDATED' ? success[400] : item.status === 'REJECTED' ? error[400] : warning[400]}14`,
                        color: item.status === 'VALIDATED' ? success[400] : item.status === 'REJECTED' ? error[400] : warning[400],
                        borderColor: `${item.status === 'VALIDATED' ? success[400] : item.status === 'REJECTED' ? error[400] : warning[400]}40`,
                        borderRadius: 100,
                      }}
                    >
                      {item.status}
                    </Tag>
                  )}
                </span>
              }
            />
          </List.Item>
        )}
      />
    </div>
  );
}
